<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the DEFAULT component for rendering the Duty activity Start (first line in a block)              -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <div>
    <v-row v-if="isTrain" class="DutyActivityStart_JB">
      <v-col cols="9">{{ time(dutyActivity.fromMinutesAfterMidnight) }}</v-col>
      <v-col cols="2" class="text-right pr-0">{{ dutyStopsById[dutyActivity.startStopIdFk].longname }}</v-col>
      <v-col cols="1" class="d-flex justify-end pl-0">
        <time-line-point :small="true" :cellHeight="34" :themeName="themeName" :topConnection="false" :bottomConnection="true" :topMargin="2"></time-line-point>
      </v-col>
    </v-row>
    <v-row v-else class="DutyActivityStart_JB pt-2">
      <v-col cols="6" class="grey--text text--darken-1">
        {{ time(dutyActivity.fromMinutesAfterMidnight) }} - {{ time(dutyActivity.toMinutesAfterMidnight) }}
      </v-col>
      <v-col cols="6" class="text-right">{{ dutyActivity.activityLongname }}</v-col>
    </v-row>
  </div>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '../../../../components/decorators/TimeLinePoint.vue';

export default {
  name: 'DutyActivityStartDefault',
  components: {
    TimeLinePoint,
  },
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
    isTrain() {
      return this.dutyActivity.activityShortname.endsWith('zug');
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
